import type { LocalAuthBinding } from '../storage/local-data-access';

/** Explicit exceptions only; absence of an account key never selects plaintext. */
export function isPlainLocalData(
  namespace: { accountKey: string },
  binding: LocalAuthBinding | null
): boolean {
  return (
    (namespace.accountKey === 'local' && binding === null) ||
    (binding !== null &&
      binding.accountId.startsWith('external:') &&
      namespace.accountKey === binding.accountId)
  );
}
